<template>
  <i class="icon" :class="`icon-${name}`" />
</template>

<script lang="ts">
export default {
  props: ["name"] as const,
}
</script>
